function isFacebookSourceBrowser(userAgent: string): boolean {
	return (
		userAgent.includes("FBAN") ||
		userAgent.includes("FBAV") ||
		userAgent.includes("Instagram")
	);
}

export default isFacebookSourceBrowser;
